export const FEATURE_LIST_SUB_CATEGORY = 'featureListSubCategory';
export const FEATURE_LIST_CATEGORY = 'featureListCategory';
export const FEATURE_LIST_SUB_SUB_CATEGORY = 'featureListSubSubCategory';
export const SPECIAL_PROGRAMS_SUB_CATEGORY = 'specialProgramsSubCategory';
export const SPECIAL_PROGRAMS_CATEGORY = 'specialProgramsCategory';
export const SPECIAL_PROGRAMS_SUB_SUB_CATEGORY = 'specialProgramsSubSubCategory';
export const RESET_SELECTED_CATEGORY = 'resetSelectedCategory';
export const SET_SUB_CAT_IDS = 'setSelectedSubCategoryIds';
export const SET_SUB_SUB_CAT_IDS = 'setSelectedSubSubCategoryIds';
